<template>
<div
  @click="handleBackgroundClick"
  id="modalRoot"
  :class="[shown ? 'shown' : 'notShown']"
  @mousemove="resizing ? dragModalResize($event) : (dragging ? dragModal($event) : null)"
  >
  <div
    ref="modal"
    id="modal"
    @mousedown="dragModalStart"
    @mouseup="dragModalStop"
    :style="`width: ${size.w}px; height: ${size.h}px;`"
    >
    <v-card
      id="modalContents"
      >
      <div
      ref="modalContentsInner"
      @click.stop
      style="height: 100%; overflow: auto">
        <slot />
      </div>
      <v-icon
        color="gray"
        x-large
        @mousedown="dragModalResizeStart"
        @mouseup="dragModalResizeStop"
        style="cursor: nwse-resize;"
        id="modalRescale">
        mdi-resize-bottom-right
      </v-icon>
    </v-card>
  </div>
</div>
</template>

<script>
export default {
  name: 'DraggableModal',
  props: ['width', 'height', 'minHeight', 'minWidth', 'autoMinHeight'],
  data () {
    return {
      modalMoveTopCorner: { x: 0, y: 0 },
      modalResizeTopCorner: { x: 0, y: 0 },
      modalResizeBottomCorner: { x: 0, y: 0 },
      size: { w: this.$props.width, h: this.$props.height },
      shown: false,
      minSize: { w: this.$props.minWidth, h: this.$props.minHeight },
      dragging: false,
      resizing: false
    }
  },

  methods: {
    handleBackgroundClick (i) {
      if (i.target.id !== 'modalRescale') {
        if (this.resizing) {
          this.resizing = false
          this.dragging = false
        } else {
          this.hide(true)
        }
      }
    },
    hide (emitEvent = false) {
      this.shown = false
      if (emitEvent) {
        // this avoids sending the event and toggling it multiple times
        this.$emit('modalDismissed')
      }
      this.dragging = false
      this.resizing = false
    },
    show () {
      this.shown = true
    },
    recalculateSize () {
      if (this.$props.autoMinHeight) {
        this.minSize.h = 0
        for (const child of this.$refs.modalContentsInner.children) {
          this.minSize.h += child.offsetHeight
        }
      }
    },
    dragModal (event) {
      if (!this.dragging || this.resizing) {
        return
      }

      if (event.x < 20) { // prevents snapping if drap past left border
        return
      }
      // get the position of the mouse and compensate for top corner
      this.$refs.modal.style.left = `${Math.max(0, Math.min(window.innerWidth - this.size.w - 100 /* right sidebar size */, event.x - this.modalMoveTopCorner.x))}px`
      this.$refs.modal.style.top = `${Math.max(0, Math.min(window.innerHeight - this.size.h - 60 /* top bar size */, event.y - this.modalMoveTopCorner.y))}px`
    },
    dragModalStart (event) {
      this.dragging = true
      // get and store the original mouse offset when user started dragging
      this.modalMoveTopCorner = {
        x: event.x - this.$refs.modal.offsetLeft,
        y: event.y - this.$refs.modal.offsetTop
      }
      // event.dataTransfer.setDragImage(new Image(), 0, 0) // hides the default preview
    },
    dragModalStop (event) {
      this.dragging = false
    },
    dragModalResize (event) {
      if (!this.resizing) {
        return
      }
      // set the size of the modal to (event.x,  event.y) - top left corner position
      this.size.w = Math.floor(Math.min(window.innerWidth - 100, Math.max(this.minSize.w, event.x - this.modalResizeBottomCorner.x))) // todo not the most accurate thing in the world
      this.size.h = Math.floor(Math.min(window.innerHeight - 100, Math.max(this.minSize.h, event.y - this.modalResizeBottomCorner.y)))

      this.$refs.modal.style.left = `${this.modalResizeTopCorner.x}px`
      this.$refs.modal.style.top = `${this.modalResizeTopCorner.y}px`
    },
    dragModalResizeStart (event) {
      // since the modal resizes in all directions, we need to adjust position each frame. So we store the position to use later
      this.modalResizeTopCorner = {
        x: this.$refs.modal.offsetLeft,
        y: this.$refs.modal.offsetTop
      }
      // calculates the minimum height so everything fits in div. However this has issues with overflow. So the hardcoded option is available
      this.recalculateSize()

      // get and store the original mouse offset when user started dragging
      this.modalResizeBottomCorner = {
        x: this.$refs.modal.offsetLeft + 90, // accounts for the side bar
        y: this.$refs.modal.offsetTop + 50// accounts for the top bar
      }
      // event.dataTransfer.setDragImage(new Image(), 0, 0) // hides the default preview

      this.resizing = true
    },
    dragModalResizeStop (event) {
      this.resizing = false
    }
  }
}
</script>
<style scoped>
#modalRoot{
  z-index: 7;
  display: flex;
  background-color: #0000005e;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 0%;
  overflow: hidden;
}
#modal{
  position: absolute;
  height: unset;
  max-height: unset;
}
#modalRescale{
  position: absolute;
  right: 0;
  bottom: 0;
  top: unset !important;
  left: unset !important;
}
#modalContents{
  position: relative;
  height: 100%;
}
.shown{
  height: 100% !important;
  transition: opacity 0.3s 0.1s;
  opacity: 1;
}
.notShown{
  opacity: 0;
  transition: opacity 0.3s 0s, height 0.1s 0.2s;
}
</style>
